import httpClient from './httpClient'

export default class {
  static async search(query, pageSize, pageNo) {
    try {
      const res = await httpClient.post(`/menu/search`, {
        query,
        pageSize,
        pageNo,
      })
      return res.data
    } catch (e) {
      console.log(e, 'error of theme.fetchThemeList')
      throw e
    }
  }

  static async searchForAdvertiser(advertiserId, startDate, pageSize) {
    try {
      const res = await httpClient.get(
        `/advertiser/${advertiserId}/managed/menu`,
        {
          params: {
            start_date: startDate,
            page_size: pageSize,
            isIncludeDeleted: false,
          },
        },
      )
      return res.data
    } catch (e) {
      console.log(e, 'error of searchForAdvertiser')
      throw e
    }
  }

  static async searchForSimulationPlan(advertiserId, agencyMargin, agencyId) {
    try {
      const res = await httpClient.get(`/simulation_plan/menu`, {
        params: {
          advertiser_id: advertiserId,
          agency_margin: agencyMargin,
          agency_id: agencyId,
        },
      })
      return res.data
    } catch (e) {
      console.log(e, 'error of searchForSimulationPlan')
      throw e
    }
  }

  static async getMenuById(menuId) {
    try {
      const res = await httpClient.get(`/menu/${menuId}`)
      return res.data
    } catch (e) {
      console.log(e, 'error getMenuById')
      throw e
    }
  }

  static async editMenu(params, menuId) {
    try {
      const res = await httpClient.put(`/menu/${menuId}`, params)
      return res.data
    } catch (e) {
      console.log(e, 'error of theme.editMenu')
      throw e
    }
  }

  static async createMenu(params) {
    try {
      const res = await httpClient.post(`/request/menu`, { params: params })
      return res.data
    } catch (e) {
      console.log(e, 'error of theme.requestMenu')
      throw e
    }
  }
  static async searchRequest(query, pageSize, pageNo) {
    try {
      const res = await httpClient.post(`/request/menu/search`, {
        query,
        pageSize,
        pageNo,
      })
      return res.data
    } catch (e) {
      console.log(e, 'error. requestMenuSearch')
      throw e
    }
  }
  static async changeRequestStatus(params, id) {
    try {
      const res = await httpClient.put(`/request/menu/${id}`, params)
      return res.data
    } catch (e) {
      console.log(e, 'error. requestApprove')
      throw e
    }
  }
  // paramのidの有無で編集と新規が切り替わる
  static async requestEdit(params) {
    try {
      const res = await httpClient.post(`/request/menu`, params)
      return res.data
    } catch (e) {
      console.log(e, 'error. requestEdit')
      throw e
    }
  }
  static async requestCancel(menuRequestId) {
    try {
      const res = await httpClient.delete(`/request/menu/${menuRequestId}`)
      return res.data
    } catch (e) {
      console.log(e, 'error. requestCancel')
      throw e
    }
  }
}
